import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const NotificationFilters = ({
  filters,
  onFilterChange,
  selectedCount,
  totalCount,
  onSelectAll,
  onBulkMarkAsRead,
  onBulkDismiss,
  onExport
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'compliance', label: 'Compliance' },
    { value: 'deadline', label: 'Deadlines' },
    { value: 'payroll', label: 'Payroll' },
    { value: 'widget', label: 'Widget Performance' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'unread', label: 'Unread' },
    { value: 'read', label: 'Read' },
    { value: 'pending', label: 'Pending' },
    { value: 'acknowledged', label: 'Acknowledged' }
  ];

  const sortOptions = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'severity', label: 'Sort by Severity' },
    { value: 'deadline', label: 'Sort by Deadline' }
  ];

  return (
    <div className="space-y-4">
      {/* Search and Filters Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
        {/* Search */}
        <div className="sm:col-span-2 lg:col-span-2">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              color="var(--color-muted-foreground)" 
              className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
            <Input
              type="text"
              placeholder="Search notifications..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="pl-10 w-full"
            />
          </div>
        </div>

        {/* Category Filter */}
        <Select
          value={filters?.category}
          onChange={(e) => onFilterChange('category', e?.target?.value)}
          className="w-full"
        >
          {categoryOptions?.map(option => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </Select>

        {/* Severity Filter */}
        <Select
          value={filters?.severity}
          onChange={(e) => onFilterChange('severity', e?.target?.value)}
          className="w-full"
        >
          {severityOptions?.map(option => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </Select>

        {/* Status Filter */}
        <Select
          value={filters?.status}
          onChange={(e) => onFilterChange('status', e?.target?.value)}
          className="w-full"
        >
          {statusOptions?.map(option => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </Select>
      </div>

      {/* Actions Row */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        {/* Left: Selection and Sort */}
        <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
          <button
            onClick={onSelectAll}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-smooth whitespace-nowrap"
          >
            <Icon name={selectedCount === totalCount ? 'CheckSquare' : 'Square'} size={18} color="currentColor" />
            <span>
              {selectedCount > 0 ? `${selectedCount} selected` : 'Select all'}
            </span>
          </button>

          <Select
            value={filters?.sortBy}
            onChange={(e) => onFilterChange('sortBy', e?.target?.value)}
            className="w-full sm:w-48"
          >
            {sortOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </Select>
        </div>

        {/* Right: Bulk Actions */}
        <div className="flex items-center gap-2 flex-wrap">
          {selectedCount > 0 && (
            <>
              <Button
                variant="outline"
                size="sm"
                onClick={onBulkMarkAsRead}
                className="flex items-center gap-2 whitespace-nowrap"
              >
                <Icon name="CheckCircle" size={16} color="currentColor" />
                <span className="hidden sm:inline">Mark as Read</span>
                <span className="sm:hidden">Read</span>
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={onBulkDismiss}
                className="flex items-center gap-2 whitespace-nowrap"
              >
                <Icon name="X" size={16} color="currentColor" />
                <span className="hidden sm:inline">Dismiss</span>
                <span className="sm:hidden">Dismiss</span>
              </Button>
            </>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <Icon name="Download" size={16} color="currentColor" />
            <span className="hidden sm:inline">Export</span>
            <span className="sm:hidden">Export</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotificationFilters;
